import styled from 'styled-components'
import { black, orange } from '@/theme/colors'

export const ImportButton = styled.button`
	display: flex;
	align-items: center;
	gap: 0.4rem;
	padding: 0.5rem 0.9rem;
	background: white;
	color: ${black};
	border: 1px solid rgba(38, 38, 38, 0.08);
	border-radius: 12px;
	font-weight: 700;
	font-size: 0.85rem;
	cursor: pointer;
	transition: all 0.15s ease;
	white-space: nowrap;

	svg {
		flex-shrink: 0;
		color: ${orange};
	}

	&:hover {
		background: #fff1ec;
	}

	&:active {
		transform: scale(0.97);
	}

	@media (max-width: 600px) {
		padding: 0.4rem 0.7rem;
		font-size: 0.8rem;
	}
`

export const MapButton = styled.button`
	display: flex;
	align-items: center;
	gap: 0.4rem;
	padding: 0.4rem 1rem;
	background: transparent;
	color: #6c757d;
	border: 1.5px solid #dee2e6;
	border-radius: 20px;
	font-weight: 600;
	font-size: 0.85rem;
	cursor: pointer;
	transition: all 0.2s ease;
	white-space: nowrap;

	svg {
		flex-shrink: 0;
	}

	&:hover {
		border-color: #adb5bd;
		color: #495057;
		background: white;
	}

	&:active {
		opacity: 0.8;
	}

	@media (max-width: 600px) {
		padding: 0.35rem 0.7rem;
		font-size: 0.8rem;
	}
`

export const ShareButton = styled.button`
	display: flex;
	align-items: center;
	gap: 0.4rem;
	padding: 0.4rem 1rem;
	background: transparent;
	color: #6c757d;
	border: 1.5px solid #dee2e6;
	border-radius: 20px;
	font-weight: 600;
	font-size: 0.85rem;
	cursor: pointer;
	transition: all 0.2s ease;
	white-space: nowrap;

	svg {
		flex-shrink: 0;
	}

	&:hover {
		border-color: #adb5bd;
		color: #495057;
		background: white;
	}

	&:active {
		opacity: 0.8;
	}

	@media (max-width: 600px) {
		padding: 0.35rem 0.7rem;
		font-size: 0.8rem;
	}
`

export const DateSelectorContainer = styled.div`
	display: flex;
	justify-content: flex-start;
	padding: 0 1rem 1.5rem 1rem;
	flex-shrink: 0;

	@media (max-width: 600px) {
		padding: 0 0.75rem 1rem 0.75rem;
	}
`

export const DateRangeDisplay = styled.div`
	display: flex;
	align-items: center;
	gap: 0.75rem;
	flex-wrap: wrap;

	@media (max-width: 600px) {
		gap: 0.5rem;
		row-gap: 0.5rem;
	}
`

export const DateDisplayText = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	white-space: nowrap;
`

export const DateDisplayValue = styled.div`
	font-size: 1.1rem;
	color: #212529;
	font-weight: 500;
	white-space: nowrap;

	@media (max-width: 600px) {
		font-size: 0.95rem;
	}
`

export const DateSeparator = styled.span`
	font-weight: 400;
	color: #6c757d;
	font-size: 0.95rem;

	@media (max-width: 600px) {
		font-size: 0.85rem;
	}
`

export const DaysCount = styled.span`
	padding: 0.4rem 1rem;
	background: white;
	color: ${black};
	border-radius: 20px;
	font-size: 0.95rem;
	font-weight: 600;
	white-space: nowrap;
	border: 2px solid #e9ecef;

	@media (max-width: 600px) {
		padding: 0.3rem 0.75rem;
		font-size: 0.85rem;
	}
`

export const EditButton = styled.button`
	background: transparent;
	color: ${orange};
	border: none;
	padding: 0;
	font-weight: 600;
	font-size: 0.95rem;
	cursor: pointer;
	transition: all 0.2s ease;
	white-space: nowrap;

	&:hover {
		opacity: 0.8;
		text-decoration: underline;
	}

	&:active {
		opacity: 0.7;
	}

	@media (max-width: 600px) {
		font-size: 0.85rem;
	}
`

